<template>
    <div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">FX Rates</h3>
			<div class="d-flex">
				<a href="#addNewRate" data-toggle="modal" class="btn btn-sm btn-outline-default shadow-sm">
					<i data-feather="plus" class="wd-10 mg-r-5"></i> Add New Rate
				</a>
			</div>
		</div>

		<div class="row">
            <div class="col-12">
                <alert-success :form="form" :class="'d-block shadow-sm'" message="FX rate was created successfully!"></alert-success>
                <alert-success :form="editForm" :class="'d-block shadow-sm'" message="FX rate was updated successfully!"></alert-success>
				<alert-success :form="deleteForm" :class="'d-block shadow-sm'" message="FX rate was deleted successfully!"></alert-success>
            </div>

			<div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="fx-rates-table" class="table">
                    <thead>
                        <tr>
                            <th class="wd-10p"></th>
                            <th class="wd-30p">Last Update</th>
                            <th class="wd-15p text-center">Currency</th>
                            <th class="wd-25p text-right"><span class="mr-4">Price Value</span></th>
                            <th class="wd-20p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
		</div>

		<div class="modal" id="addNewRate" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<form class="modal-content" @submit.prevent="addNewRate">
                    <div class="modal-header">
                        <button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title">New Rate</h5>
                    </div>
					<div class="modal-body">
						<div class="form-group">
							<label>Currency</label>
							<input v-model="form.currency" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('currency') }" name="currency" placeholder="Enter rate name" required>
							<has-error :form="form" field="currency"></has-error>
						</div>
						<div class="form-group">
							<label>Initial Price Value</label>
							<input v-model="form.price_value" type="number" step="any" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('price_value') }" name="price_value" placeholder="Enter rate price value" required>
							<has-error :form="form" field="price_value"></has-error>
						</div>
					</div>
					<div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
							<button type="submit" class="btn btn-default shadow-sm mg-b-5 mg-sm-b-0">Add Rate</button>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div>

        <div class="modal" id="editRate" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<form class="modal-content" @submit.prevent="editRate">
                    <div class="modal-header">
                        <button type="button" class="close pos-absolute t-15 r-20" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
						<h5 class="modal-title">Edit Rate</h5>
                    </div>
					<div class="modal-body">
						<div class="form-group">
							<label>Currency</label>
							<input v-model="editForm.currency" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': editForm.errors.has('currency') }" name="currency" placeholder="Enter rate name" required>
							<has-error :form="editForm" field="currency"></has-error>
						</div>
						<div class="form-group">
							<label>Initial Price Value</label>
							<input v-model="editForm.price_value" type="number" step="any" class="form-control shadow-sm" :class="{ 'is-invalid': editForm.errors.has('price_value') }" name="price_value" placeholder="Enter rate price value" required>
							<has-error :form="editForm" field="price_value"></has-error>
						</div>
					</div>
					<div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
							<button type="submit" class="btn btn-default shadow-sm mg-b-5 mg-sm-b-0">Update Rate</button>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</form>
			</div>
		</div>

        <div class="modal" id="deleteRate" tabindex="-1" role="dialog" aria-labelledby="deleteRateModal" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <form class="modal-content" @submit.prevent="deleteRate">
                    <div class="modal-header">
                        <h5 class="modal-title" id="deleteRateModal">Delete Rate</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="mg-b-0">Are you sure you want to delete this FX rate?</p>
                    </div>
                    <div class="modal-footer">
						<div class="wd-100p d-flex flex-column flex-sm-row">
							<button type="submit" class="btn btn-danger shadow-sm mg-b-5 mg-sm-b-0 col-6">Yes, Delete</button>
							<button type="button" class="btn btn-primary shadow-sm mg-sm-l-5 col-6" data-dismiss="modal">No, Cancel</button>
						</div>
					</div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		mounted() {
			this.table = $("#fx-rates-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`
					},
					url: "/api/fx-rates?datatable=true",
					dataFilter: data => {
						var json = JSON.parse(data);

						return JSON.stringify(json.data);
					}
				},
				responsive: true,
				deferRender: true,
				columnDefs: [
					{
						targets: 0,
						visible: false
					},
					{
						targets: [0, 2, -1],
						className: "text-center"
					},
					{
						targets: 3,
						className: "text-right"
					},
					{
						targets: -1,
						orderable: false,
						data: "id",
						render: function(data, type, row, meta) {
							return (
								`<button href="#editRate" data-toggle="modal" data-action="edit" data-row="${meta.row}" class="btn btn-sm btn-white shadow-sm mr-2"><i data-feather="edit-2" class="wd-10 mg-r-5"></i> Edit</button>` +
								`<button href="#deleteRate" data-toggle="modal" data-action="delete" data-row="${meta.row}" class="btn btn-sm btn-danger shadow-sm"><i data-feather="trash-2" class="wd-10 mg-r-5"></i> Delete</button>`
							);
						}
					}
				],
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No fx rates available."
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
				drawCallback: settings => {
					feather.replace();
				}
			});

			$("#fx-rates-table tbody").on("click", "button", e => {
				const data = this.table.row(e.target.dataset.row).data();

				if (e.target.dataset.action === "edit") {
					this.editForm.fill({
						id: data[0],
						currency: data[2],
						price_value: data[3]
					});
				}

				if (e.target.dataset.action === "delete") {
					this.deleteForm.fill({
						id: data[0]
					});
				}
			});

			$("#addNewRate, #editRate, #deleteRate").on("hidden.bs.modal", e => {
				this.form.reset();
				this.editForm.reset();
			});
		},
		data() {
			return {
				table: null,
				form: new Form({
					currency: null,
					price_value: null
				}),
				editForm: new Form({
					id: null,
					currency: null,
					price_value: null
				}),
				deleteForm: new Form({
					id: null
				})
			};
		},
		methods: {
			addNewRate() {
				this.form.post("/api/fx-rates").then(({ data }) => {
					this.table.ajax.reload();
					$("#addNewRate").modal("hide");
				});
			},
			editRate() {
				this.editForm
					.patch(`/api/fx-rates/${this.editForm.id}`)
					.then(({ data }) => {
						this.table.ajax.reload();
						$("#editRate").modal("hide");
					});
			},
			deleteRate() {
				this.deleteForm
					.delete(`/api/fx-rates/${this.deleteForm.id}`)
					.then(({ data }) => {
						this.table.ajax.reload();
						$("#deleteRate").modal("hide");
					});
			}
		}
	};
</script>
